<div class="circle-container" [style]="customStyles" ngbTooltip="
        {{levels[currentValue-1] | translate}}">
    <div *ngFor="let level of levels; let i = index" class="circle" [class.filled-circle]="i < currentValue"
        [class.empty-circle]="i >= currentValue">
    </div>
</div>
